// extracted by mini-css-extract-plugin
export var cardTitle = "_jn-1";
export var commentBubble = "_jn-e";
export var commentForm = "_jn-a";
export var commentInput = "_jn-b";
export var commentLabel = "_jn-d";
export var commentPrompt = "_jn-9";
export var csatCard = "_jn-0";
export var feedbackSection = "_jn-7";
export var starDisabled = "_jn-6";
export var starEmpty = "_jn-5";
export var starFilled = "_jn-4";
export var starWrapper = "_jn-3";
export var starsContainer = "_jn-2";
export var submittedComment = "_jn-c";
export var thankYouText = "_jn-8";